<template>
    <div>
        <div class="banner" v-if="width >=1200">
            <div class="banner-img">
                <img v-for="(item,index) in list" :key="index" :src="imgserver + item.picture" />
            </div>
            <div class="banner-title" v-for="(item,index) in list" :key="index">
                <div style="width:1440px;margin:0 auto;">
                    <p style="color:#fff;">{{ item.mainTitle }}</p>
                    <p style="color:#fff" class="content" >{{ item.subTitle }}</p>
                </div>
            </div>
        </div>
        <!-- 移动端 -->
        <div class="banner" v-else>
            <div class="banner-img">
                <img v-for="(item,index) in list" :key="index" :src="imgserver + item.picture" />
            </div>
            <div class="banner-title" v-for="(item,index) in list" :key="index">
                <div style="width:1440px;margin:0 auto;">
                    <p style="color:#fff">{{ item.mainTitle }}</p>
                    <p style="color:#fff" class="content" >{{ item.subTitle }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { getBanner } from '../api/api'
export default {
  name: "Banner",
    props: {
        title: {
            type: String,
            default: ""
        },
        content: {
            type: String,
            default: ""
        },
        // img: {
        //     type: String,
        //     // default: require("../assets/img/banner.png")
        // },
        type:{
            type:String,
            default:""
        }
    },
    data () {
        return {
            list:[],
            img:'',
            width:document.documentElement.clientWidth
        }
    },
    destroyed(){
    },
    mounted () {
      window.onresize = () => {
        return (() => {
          this.width = document.documentElement.clientWidth // 宽
        })()
      }
        this.onload()
    },
    watch: {
        type(newVal,old){
            console.log(newVal , 'nnnnnnn');
            this.type = newVal
            this.onload()
        }
    },
    methods: {
       onload(){
        getBanner({bannerType:this.type}).then(res => {
            this.list = res.data.data
            // this.img = imgserver + res.data[0].picture
            console.log(this.list,'iii');
        })
       }
    }
};
</script>

<style lang="scss" scoped>
    @import url('../assets/font/font.css');
  @media (min-width:1200px) {
    .banner {
        width: 100%;
        height: 400px;
        display: flex;
        position: relative;
        overflow: hidden;
        // background-color: #fff;
        box-sizing: border-box;
        font-family: Microsoft YaHei;
      font-size: 16px;
        .banner-img{
            width: 100%;
            height: 100%;
        }
        img {
            width: 100%;
            height: 100%;
            background-size: cover;
        }

        &-title {
            position: absolute;
            top: 35%;
            // padding: 0 220px;
            width: 100%;
            font-size: 64px;
            font-weight: bold;
            line-height: 58px;
            letter-spacing: 0px;
            color: #fff;
            box-sizing: border-box;
        }
        .content{
            font-size: 24px;
            font-weight: normal;
            line-height: normal;
            letter-spacing: 0px;
            color: #fff;
            margin-top: 20px;
            white-space: pre-wrap;
        }
    }
  }
  @media (max-width:1200px) {
    .banner {
        width: 100%;
        height: 200px;
        display: flex;
        position: relative;
        overflow: hidden;
        // background-color: #fff;
        box-sizing: border-box;
        font-family: Microsoft YaHei;
      font-size: 16px;
        .banner-img{
            width: 100%;
            height: 100%;
        }
        img {
            width: 100%;
            height: 100%;
            background-size: cover;
        }

        &-title {
            position: absolute;
            top: 35%;
            padding-left: 15px;
            // padding: 0 220px;
            width: 100%;
            font-size: 16px;
            font-weight: bold;
            line-height: 58px;
            letter-spacing: 0px;
            color: #fff;
            box-sizing: border-box;
        }
        .content{
            font-size: 10px;
            font-weight: normal;
            line-height: normal;
            letter-spacing: 0px;
            color: #fff;
            // margin-top: 20px;
            white-space: pre-wrap;
        }
    }
  }
</style>
